import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { runInAction } from 'mobx';
import { FormQuestionType, FormStatus } from '../../../form-system/models/Form';
import { RichTextFormat } from '../../models/RichTextFormat';
import { validate } from '../../models/validators';
var shouldOverwriteAnswerWithFieldValueAnswer = function shouldOverwriteAnswerWithFieldValueAnswer(fieldValueAnswer) {
  // Assume that if there is a non-empty answer in the field data response, that we should prefer that
  // over whatever is currently in the form. At the time of writing, this only occurs for async choice fields
  // default answer values on portal create / issue forms.
  var isFieldValueAnswerEmpty = Object.keys(fieldValueAnswer).length === 0;
  return !isFieldValueAnswerEmpty;
};
var getRichTextFormat = function getRichTextFormat(formQuestionType) {
  if (formQuestionType === FormQuestionType.RichTextParagraph) {
    return RichTextFormat.Adf;
  } else if (formQuestionType === FormQuestionType.TextParagraph) {
    return RichTextFormat.Wiki;
  }
  return undefined;
};
export var loadFieldDataFn = function loadFieldDataFn(requestFieldData, errorUtils) {
  var isAlwaysOverwriteEmptyLinkedFields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (formStore) {
    return function () {
      // Build a map of all linked Jira fields used by this form:
      var fieldsInUse = formStore.questions.reduce(function (fieldsInUse, questionStore) {
        if (questionStore.formQuestion.jiraField) {
          fieldsInUse.push({
            fieldKey: questionStore.formQuestion.jiraField,
            format: getRichTextFormat(questionStore.formQuestion.type)
          });
        }
        return fieldsInUse;
      }, []);
      if (fieldsInUse.length === 0) {
        return Promise.resolve();
      }
      return requestFieldData({
        fields: fieldsInUse
      }).then(function (fieldData) {
        var validationResult = validate('ApiFieldDataResponseSchema', fieldData);
        if (!validationResult.isValid) {
          errorUtils.reportError(new Error('Response type mismatch'), {
            id: 'ApiFieldDataResponseSchema',
            attributes: {
              errors: JSON.stringify(validationResult.errors)
            }
          });
          return;
        }
        var fieldMap = new Map(Object.entries(fieldData));
        runInAction(function () {
          formStore.questions.forEach(function (questionStore) {
            if (questionStore.formQuestion.jiraField && fieldMap.has(questionStore.formQuestion.jiraField)) {
              // The API and UI code have slightly different representations of answers, so choices and users need to be converted:
              var issueFieldData = fieldMap.get(questionStore.formQuestion.jiraField);
              var issueFieldValue = issueFieldData.value;
              var answer = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, issueFieldValue.text && {
                text: issueFieldValue.text
              }), issueFieldValue.adf && {
                adf: issueFieldValue.adf
              }), issueFieldValue.date && {
                date: issueFieldValue.date
              }), issueFieldValue.time && {
                // jira time value includes seconds which ProForma doesn't use, so trim them
                time: !!issueFieldValue.time.match(/^\d+:\d+:\d+$/) ? issueFieldValue.time.replace(/:\d+$/, '') : issueFieldValue.time
              }), issueFieldValue.choices && {
                choices: issueFieldValue.choices.map(function (choice) {
                  return choice.id;
                })
              }), issueFieldValue.users && {
                users: issueFieldValue.users
              });
              questionStore.setIssueFieldData(issueFieldData);
              if (formStore.status === FormStatus.Open) {
                if (isAlwaysOverwriteEmptyLinkedFields || shouldOverwriteAnswerWithFieldValueAnswer(answer)) {
                  questionStore.setAnswerFromFieldValue(answer);
                  questionStore.setAnswerChoicesAsObjects(issueFieldValue.choices || []);
                }
              }
            }
          });
        });
      });
    };
  };
};